// extracted by mini-css-extract-plugin
export default {"block":"Event_block__s3tkz","bg":"Event_bg__-EH44","main":"Event_main__29X7M"};